import React, { Component } from 'react'
import AccessGridFilterCustomerItem from "./AccessGridFilterCustomerItem";

export default class AccessGridFilterCustomerContainer extends Component {

    render() {
        let items = [];
        this.props.items.forEach((item) => {
            items.push(<AccessGridFilterCustomerItem key={item.login} userName={item.userName} login={item.login} onFilter={this.props.onFilter}/>);
        });
        return (
            <div style={{display: 'flex', flexDirection: 'column', marginTop: 5, position: 'absolute', height: window.$(window).innerHeight() - 55,
                width: 300, overflowY: 'auto', backgroundColor: '#bbb'}}>
                <AccessGridFilterCustomerItem userName={'Все'} login={''} onFilter={this.props.clearFilter}/>
                {items}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/grids/AccessGridFilterCustomerContainer.js